import { Status } from './api/api';
export var DayState;
(function (DayState) {
    DayState[DayState["Current"] = 1] = "Current";
    DayState[DayState["Past"] = 2] = "Past";
    DayState[DayState["Future"] = 3] = "Future";
})(DayState || (DayState = {}));
export var Currency;
(function (Currency) {
    Currency["bnb"] = "bnb";
    Currency["btc"] = "btc";
    Currency["cad"] = "cad";
    Currency["dai"] = "dai";
    Currency["doge"] = "doge";
    Currency["eth"] = "eth";
    Currency["eur"] = "eur";
    Currency["gbp"] = "gbp";
    Currency["jpy"] = "jpy";
    Currency["ltc"] = "ltc";
    Currency["matic"] = "matic";
    Currency["mnt"] = "mnt";
    Currency["pol"] = "pol";
    Currency["sol"] = "sol";
    Currency["trx"] = "trx";
    Currency["usd"] = "usd";
    Currency["usdc"] = "usdc";
    Currency["usdt"] = "usdt";
})(Currency || (Currency = {}));
export var CryptoCurrency;
(function (CryptoCurrency) {
    CryptoCurrency["bnb"] = "bnb";
    CryptoCurrency["btc"] = "btc";
    CryptoCurrency["doge"] = "doge";
    CryptoCurrency["eth"] = "eth";
    CryptoCurrency["invalid"] = "invalid";
    CryptoCurrency["ltc"] = "ltc";
    CryptoCurrency["matic"] = "matic";
    CryptoCurrency["usdc"] = "usdc";
    CryptoCurrency["usdt"] = "usdt";
})(CryptoCurrency || (CryptoCurrency = {}));
export const successCodes = [
    Status.ACCEPTED,
    Status.APPROVED,
    Status.AVAILABLE,
    Status.SUCCESS,
    Status.OK,
    Status.FOUND,
    Status.COMPLETED,
    Status.CONFIRMED,
    Status.READY
];
export const isSuccessStatus = (status) => {
    return successCodes.includes(status ?? Status.FAILED);
};
